export const TARGET_MAIN_OPTION = {
  value: 'all',
  label: 'All Locations',
};
